<template>
  <div class="box-img-7">
    <img class="bg-img" :src="require('$img/card-bg-7.jpg')" alt="">
    <div class="company" v-if="info.company">
      <div class="company-name">
        {{info.company.short_name !== '' ? info.company.short_name : info.company.name}}
      </div>
      <img v-if="info.company.logo !== ''" :src="info.company.logo+'?imageView2/1/w/100/h/100/q/100'" alt="">
    </div>

    <div class="txt-box">
      <div class="line-box" style="margin-left: 350px;height: 235px;margin-bottom: 0">
        <div class="l-b-t" style="font-size: 21px;">
          <div>岗位</div>
          <div class="l-b-t-border"></div>
        </div>

        <div class="l-b-other" style="margin-bottom: 10px;line-height: 40px">{{info.post}}</div>
        <div class="l-b-last" style="font-size: 19px" v-if="info.feature">{{featureTxt}}</div>
      </div>

      <div class="line-box" style="margin-top: 50px">
        <div class="l-b-t" >
          <div>项目/公司</div>
          <div class="l-b-t-border"></div>
        </div>
        <div class="l-b-last">{{info.project_name}}</div>
      </div>

      <div v-if='moneyTxt' class="line-box">
        <div class="l-b-t">
          <div>薪酬待遇</div>
          <div class="l-b-t-border"></div>
        </div>
        <div class="l-b-last">{{moneyTxt}}</div>
      </div>

      <div v-if='adderTxt' class="line-box">
        <div class="l-b-t">
          <div>工作地点</div>
          <div class="l-b-t-border"></div>
        </div>
        <div class="l-b-last ">
          <div class="address">{{adderTxt}}</div>
        </div>
      </div>

    </div>
    <div class="code">
      <img :src="code" alt="" @load="imgLoad">
      <p>扫码求职，在线投递简历</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card1',
  props: ['info', 'code'],
  computed: {
    featureTxt () {
      let txt = this.info.feature.replace(/,/g, ' / ')
      return txt
    },
    moneyTxt () {
      let str=''
      if(this.info.treatment_min&&!this.info.treatment_max){
        str=this.info.treatment_min+'k/月'
      }else if(!this.info.treatment_min&&this.info.treatment_max){
        str=this.info.treatment_max+'k/月'
      }else if(this.info.treatment_min&&this.info.treatment_max){
        str=this.info.treatment_min+'k-'+this.info.treatment_max+'k/月'
      }
      if(this.info.treatment.length>0){
        if (this.info.treatment.length >= 20) {
          str = str+' '+this.info.treatment.substring(0,20)
          return str + '...'
        }else{
          str = str+' '+this.info.treatment;
        }
      }
      return str
    },
    adderTxt () {
      // let adder = this.info.project_address.split(',')
      // let adderArr = adder.filter(val => val !== '-')
      // return adderArr.join('-')
      let adderArr=this.info.province+'-'+this.info.city
      if(this.info.area)adderArr=adderArr+'-'+this.info.area;
      if(this.info.plate)adderArr=adderArr+'-'+this.info.plate;
      if(this.info.project_address!='-'&&this.info.project_address)adderArr=adderArr+'-'+this.info.project_address;
      if (adderArr.length >= 25) {
        adderArr = adderArr.substring(0,25)
        return adderArr + '...'
      }
      return adderArr
    }
  },
  methods: {
    imgLoad () {
      this.$emit('codeImgLoad')
    }
  }
}
</script>

<style lang="scss">
@import '$styles/global.scss';

.box-img-7{
  width: 600px;
  height: 1300px;
  position: relative;
  z-index: 2;

  .company{
    position: absolute;
    right: 29px;
    top: 23px;
    @include flex-box(flex-start);

    img{
      height: 59px;
      width: 59px;
      border: 1px solid rgba($color: #FFF, $alpha: .3);
      border-radius: 2px;
      background: #FFF;
    }

    .company-name{
      font-size: 19px;
      color: #333642;
      margin-left: 5px;
    }
  }

  .bg-img{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }

  .txt-box{
    width: 100%;
    padding-right: 40px;
    position: absolute;
    top: 430px;
    right: 0;
    box-sizing: border-box;

    .line-box{
      width: 250px;
      margin-bottom: 46px;
      margin-left: 290px;
      flex-direction: column;
      @include flex-box(flex-start);
      .l-b-t{
        font-size: 16px;
        color: #2A2A2A;
        width: 100%;
        font-weight: 500;
        margin-bottom: 10px;
        div:nth-child(1) {

        }
      }

      /*.l-b-t-border{*/
      /*  height: 6px;*/
      /*  width: 100%;*/
      /*  border-radius: 1px;*/
      /*  background: linear-gradient(to right, #6DC1F8, #30A9F9);*/
      /*}*/

      .l-b-other{
        width: 100%;
        margin-bottom: 4px;
        font-weight: 500;
        font-size: 38px;
        color: #2A2A2A;

      }

      .l-b-last{
        width: 100%;
        box-sizing: border-box;
        padding-right: 40px;
        font-size: 21px;
        color: #2A2A2A;
        // @include text-ellipsis(2);
      }

      .address{
        width: 245px;
      }
    }
  }

  .code{
    position: absolute;
    bottom: 15px;
    right: 0;
    left: 0;
    margin: 0 auto;
    text-align: center;

    img{
      width: 156px;
      height: 156px;
      border-radius: 50%;
      background-color: #FFF;
      padding: 10px;
      box-sizing: border-box;
    }

    p{
      font-size: 19px;
      color: #515467;
    }
  }
}
</style>
